import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { atom } from 'jotai';
import { User } from 'shared/models';

export interface IUserFollowerData {
  cursor: number;
  hasMore: boolean;
  data: User[];
}

type TUserFollowerStore = { [key: string]: IUserFollowerData };

export const $UserFollowerStore = atom({} as TUserFollowerStore);

export const $UserFollower = safeAtomFamily((userLinkName: string) => {
  const a = atom(
    (get) => {
      return get($UserFollowerStore)[userLinkName];
    },
    (get, set, input: IUserFollowerData) => {
      const old = get($UserFollowerStore);

      set($UserFollowerStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserFollower+${encodeURIComponent(userLinkName)}`;

  return a;
});

export const $UserFollowerLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom(null, (get, set, input: IUserFollowerData) => {
    const old = get($UserFollower(userLinkName));
    set($UserFollower(userLinkName), {
      ...input,
      data: [...old.data, ...input.data],
    });
  });

  a.debugLabel = `$UserFollowerLoadmore+${encodeURIComponent(userLinkName)}`;

  return a;
});
